<template>
  <div class="pageToast pageToast1">
    <div class="listEmpty" v-if="this.type==1">{{$t('pagetoast.empty')}}</div>
    <div class="pageLoading flex-center-y flex-center-x" v-if="this.type==2">
      <span class="icon iconfont icon-jiazai"></span>
      {{$t("common.loaidng_get_data")}}...
    </div>
    <div class="netError" v-if="this.type==3">{{$t("common.service_error")}}~</div>
    <div class="notLogin" v-if="this.type==4">
      {{ $t("common.no_login") }}
      <a href="/login">{{ $t("common.login_click") }}</a>
    </div>
    <div class="noresponse" v-if="this.type==5">{{ $t("common.service_over") }}~</div>
    <div class="noNet" v-if="this.type==6">{{$t("common.no_net")}}~</div>
    <div class="listEmptysmall" v-if="this.type==7">{{ $t("common.no_data") }}~</div>

    <div v-if="msg" class="listEmpty">{{msg}}</div>
  </div>
</template>
<script>
export default {
  props: {
    msg: {
      type: String,
      default: ""
    }
  },
  data () {
    return {
      type: 0
    };
  }
};
</script>
<style>
.pageToast.pageToast1 {
  margin: 0 auto;
}
.listEmpty {
  font-size: 15px;
  text-align: center;
  padding-top: 180px;
  background: url("~@/assets/images/nody.png") no-repeat center top;
  background-size: auto 155px;
  height: 100%;
  margin-top: 1rem;
  float: left;
  width: 100%;
  opacity: 0.3;
}
.listEmptysmall {
  font-size: 14px;
  text-align: center;
  padding-top: 80px;
  background: url("~@/assets/images/nody.png") no-repeat center top;
  background-size: auto 80px;
  height: 100%;
  width: 100%;
  margin: 0.3rem auto;
  color: #999;
}
.pageLoading {
  text-align: center;
  line-height: 30px;
  font-size: 14px;
  color: #999;
  padding: 30px 0;
}
.pageLoading span {
  display: inline-block;
  width: 30px;
  height: 30px;
  margin-right: 5px;
  font-size: 24px;
  animation: rotate 1s linear infinite;
}
.netError {
  text-align: center;
  line-height: 30px;
  font-size: 14px;
  color: #999;
  padding: 30px 0;
}
.notLogin {
  text-align: center;
  line-height: 30px;
  font-size: 14px;
  color: #999;
  padding: 30px 0;
}
.notLogin a {
  display: inline;
  color: #2f9dff;
  margin-right: 3px;
}
.noresponse {
  text-align: center;
  line-height: 30px;
  font-size: 14px;
  color: #999;
  padding: 30px 0;
}
.noNet {
  text-align: center;
  line-height: 30px;
  font-size: 14px;
  color: #999;
  padding: 30px 0;
}
@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
